export default {
  data() {
    return {
      inApp: false,
      isWeixin: false
    }
  },
  created() {
    this.judgementApp()
    this.isWeixin = this.$isWeixin()
  },
  methods: {

    // 判断是否在app
    judgementApp() {
      this.inApp = this.$getIsApp()
    }
  }
}
